import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { useSelector,useDispatch } from "react-redux";
import FieldSetCheckboxes from "../fieldSetCheckboxes/fieldSetCheckboxes";
//store
import { clearFilter,setLoading } from "../../configureStore";
// helpers
import ButtonResults from "./buttonResults";
Modal.setAppElement("#root");
const FiltersModal = (props) => {
	const dispatch = useDispatch();
	const [modalIsOpen, setIsOpen] = useState(false);
	const [allowedDiscount, setAllowedDiscount] = useState(false);
	const [hideAmenities, setHideAmenities] = useState(false);
	const global = useSelector((state) => state.global);
	const facilityList = useSelector((state) => state.facilityList);
	const searchData = useSelector((state) => state.searchData);
	const activityGroup = useSelector(
		(state) => state.initialData.activitiesGroup,
	);
	const amenity = useSelector((state) => state.initialData.amenities);
	const discountCategories = useSelector(
		(state) => state.initialData.discountCategories,
	);
	const cards = useSelector((state) => state.initialData.cards);
	const language = global.localization;
	const facilityTotal = useSelector((state) => state.facilityList.facilities.length);
	// single-time read
	useEffect(() => {
		if (props.toggleModal) {
			openModal();
			availableDiscounts();
		}
	}, [props.toggleModal]);
	// if no result in  search have amenity, hide amenities from filters
	useEffect(() => {
		if (!facilityList.facilities.length) return;
		const payload = facilityList.facilities;
		const filtered = payload.every((item) => {
			return item.amenities === null || item.amenities.length < 1;
		});
		setHideAmenities(filtered);
	}, [facilityList]);
	const openModal = () => {
		setIsOpen(true);
		props.callback();
	};

	const closeModal = () => {
		setIsOpen(false);
	};
	const constructUrl = () => {
		if (window.initialState.page === "search") {
			closeModal();
		} else {
			const searchParams = window.location.search;
			window.location= `${window.initialState.locationsUrl}/${searchParams}`;
		}
	};
	const clearFiltersMobile = async() => { 
		await dispatch(clearFilter());
		dispatch(setLoading(true));
	}
	const availableDiscounts = () => {
		const cardsInData = searchData.cards;
		const cardsInitialData = cards;
		if (cardsInData.length < 1 || cardsInitialData.length < 1) {
			setAllowedDiscount(false);
		}
		setAllowedDiscount(false);
		cardsInData.forEach((card) => {
			cardsInitialData.forEach((initCard) => {
				if (initCard.cardId == card && initCard.allowedForDiscounts) {
					setAllowedDiscount(true);
					return;
				}
			});
		});
	};
	function renderFields() {
		return (
			<>
				{activityGroup.length ? (
					<FieldSetCheckboxes
						showmore={language.showMore}
						showless={language.showLess}
						options={activityGroup}
						label={global.localization.activities}
						type="activityGroup"
					/>
				) : null}
				{discountCategories.length && allowedDiscount ? (
					<FieldSetCheckboxes
						showmore={language.showMore}
						showless={language.showLess}
						options={discountCategories}
						label={global.localization.discounts}
						type="discountCategory"
					/>
				) : null}
				{amenity.length && hideAmenities === false ? (
					<FieldSetCheckboxes
						showmore={language.showMore}
						showless={language.showLess}
						options={amenity}
						label={global.localization.amenities}
						type="amenity"
					/>
				) : null}
			</>
		);
	}
	return (
		<div>
			<Modal
				portalClassName={"modal-app"}
				overlayClassName={"modal-app__overlay"}
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				closeTimeoutMS={200}
				className="modal-app__wrapper"
				contentLabel="filters Modal">
				<div className="modal-app__header">
					<h2 className="modal-app__title">{language.filters}</h2>
					<button
						className="modal-app__close"
						aria-label="close"
						onClick={closeModal}>
						<div className="icon">
							<img
								src="/assets/images/close.svg"
								alt="X"
							/>
						</div>
					</button>
				</div>
				<div className="form">
					<div className="modal-app__cont">{renderFields()}</div>
					<div className="modal-app__footer">
						<div className="button-row button-row--end">
							<div className="button-row__list">
								<button
									type="button"
									className="button-link"
									onClick={clearFiltersMobile}>
									{language.clearFilters}
								</button>
								<ButtonResults
									label={
										window.initialState.page === "search"
											? language.showResults.replace("${value}", facilityTotal)
											: language.showResults.replace("${value}", "")
									}
									callback={constructUrl}
								/>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default FiltersModal;
